import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../state/state.types';
import { search } from '../../../search/state/actions';

function mapState({ results, layout, searchMenu }: StateType) {
  const hasQuery = results.query.length > 0;
  return {
    hasQuery,
    shouldDisplaySearch: results.searchLoading || results.loaded,
    searchFiltersOpen: searchMenu.isOpen,
    isMarketingLayout: layout.hideSearch,
  };
}

const mapDispatch = (dispatch: Function) => ({
  autoSearch: () => {
    dispatch(search({ reason: 'original_query' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
